import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaTimes,
  FaUser,
  FaIdCard,
  FaPhone,
  FaEnvelope,
  FaBriefcase,
  FaBuilding,
  FaUserTie,
  FaShare,
  FaBullhorn,
  FaMoneyBillWave,
  FaSignInAlt,
  FaCheck,
  FaSpinner,
  FaClipboardList,
  FaRoute,
  FaUserTag,
  FaStar,
} from "react-icons/fa";
import CommonModal from "Components/CommonModal";
import { outClick, catchError } from "JS/common";
import { adminLogin, getUserInfo } from "JS/API";

const PersonnelModal = ({ setInfoModal, id }) => {
  // State declarations
  const [info, setInfo] = useState({});
  const [alert, setAlert] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [loginLoading, setLoginLoading] = useState(false);
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  
  let prevent = false;
  const navigate = useNavigate();

  // 스타일 정의
  const styles = {
    modalBackground: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modalContainer: {
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.05)',
      width: '100%',
      maxWidth: '600px',
      maxHeight: '90vh',
      overflow: 'hidden',
      animation: 'modalSlideIn 0.3s ease-out'
    },
    modalHeader: {
      padding: '24px 32px',
      background: 'rgb(241, 245, 249)',
      color: 'black',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: '600',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    headerActions: {
      display: 'flex',
      gap: '12px',
      alignItems: 'center'
    },
    loginButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '8px 16px',
      backgroundColor: '#06c',
      color: '#ffffff',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      // transition: 'all 0.2s ease',
      // backdropFilter: 'blur(10px)'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      color: 'black',
      cursor: 'pointer',
      padding: '8px',
      borderRadius: '6px',
      transition: 'background-color 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modalContent: {
      padding: '32px',
      maxHeight: 'calc(90vh - 120px)',
      overflowY: 'auto'
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px',
      color: '#6b7280'
    },
    spinner: {
      width: '32px',
      height: '32px',
      border: '3px solid #e5e7eb',
      borderTop: '3px solid #667eea',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: '16px'
    },
    fieldsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '24px'
    },
    fieldGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    fieldGroupFull: {
      gridColumn: '1 / -1'
    },
    fieldLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '4px'
    },
    fieldValue: {
      padding: '12px 16px',
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      fontSize: '14px',
      color: '#1e293b',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    statusIndicator: {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: '700'
    },
    statusYes: {
      backgroundColor: '#dcfce7',
      color: '#166534'
    },
    statusNo: {
      backgroundColor: '#fef2f2',
      color: '#991b1b'
    },
    phoneNumber: {
      fontFamily: 'monospace',
      letterSpacing: '0.5px'
    },
    sectionTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      paddingTop: '20px',
      borderTop: '1px solid #e2e8f0',
      fontSize: '15px',
      fontWeight: '700',
      color: '#1e293b'
    },
    sectionMeta: {
      marginLeft: 'auto',
      fontSize: '13px',
      fontWeight: '500',
      color: '#64748b'
    },
    chipList: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '6px'
    },
    chip: {
      padding: '4px 10px',
      borderRadius: '999px',
      backgroundColor: '#eff6ff',
      border: '1px solid #bfdbfe',
      color: '#1d4ed8',
      fontSize: '13px',
      fontWeight: '500'
    }
  };

  // API 호출 함수
  const getUserDetail = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => {
      prevent = false;
    }, 200);

    try {
      const result = await getUserInfo(id);
      if (typeof result === "object") {
        setInfo(result?.data?.data);
      } else {
        return await catchError(result, navigate, setAlertBox, setAlert);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // 로그인 핸들러
  const handleLogin = async () => {
    const data = {
      user_pk: id,
      expires_in_days: '1',
    };

    setLoginLoading(true);

    try {
      const response = await adminLogin(data);
      if (response?.data?.impersonate_url) {
        const url = response.data?.impersonate_url;
        window.open(url, "_blank");
      } else {
        throw new Error("URL 없음");
      }
    } catch (error) {
      setAlertBox({
        mode: "alert",
        context: "로그인에 실패했습니다.",
        bool: true,
      });
    } finally {
      setLoginLoading(false);
    }
  };

  // 전화번호 포맷팅
  const formatPhoneNumber = (phone) => {
    if (!phone) return '-';
    if (phone.length === 11) {
      return `${phone.slice(0, 3)}-${phone.slice(3, 7)}-${phone.slice(7)}`;
    }
    return phone;
  };

  // 상태 인디케이터 렌더링
  const renderStatusIndicator = (status, trueText, falseText) => (
    <div style={styles.fieldValue}>
      <div style={{
        ...styles.statusIndicator,
        ...(status ? styles.statusYes : styles.statusNo)
      }}>
        {status ? <FaCheck size={10} /> : <FaTimes size={10} />}
      </div>
      <span>{status ? trueText : falseText}</span>
    </div>
  );

  // 초기화
  useEffect(() => {
    window.addEventListener("click", (e) => outClick(e, setInfoModal));
    getUserDetail();
    return () => {
      window.removeEventListener("click", (e) => outClick(e, setInfoModal));
    };
  }, []);

  return (
    <>
      <div style={styles.modalBackground}>
        <div style={styles.modalContainer}>
          {/* 모달 헤더 */}
          <div style={styles.modalHeader}>
            <h3 style={styles.modalTitle}>
              <FaUser />
              회원 상세보기
            </h3>
            <div style={styles.headerActions}>
              <button
                style={styles.loginButton}
                onClick={handleLogin}
                disabled={loginLoading}
              >
                {loginLoading ? (
                  <>
                    <FaSpinner className="spinning" />
                    로그인 중...
                  </>
                ) : (
                  <>
                    <FaSignInAlt />
                    계정으로 로그인
                  </>
                )}
              </button>
              <button
                style={styles.closeButton}
                onClick={() => setInfoModal(false)}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                <FaTimes size={16} />
              </button>
            </div>
          </div>

          {/* 모달 콘텐츠 */}
          <div style={styles.modalContent}>
            {isLoading ? (
              <div style={styles.loadingContainer}>
                <div style={styles.spinner}></div>
                <div>사용자 정보를 불러오는 중...</div>
              </div>
            ) : (
              <div style={styles.fieldsGrid}>
                {/* 기본 정보 */}
                <div style={styles.fieldGroup}>
                  <label style={styles.fieldLabel}>
                    <FaIdCard />
                    아이디
                  </label>
                  <div style={styles.fieldValue}>
                    {info?.user_id || '-'}
                  </div>
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.fieldLabel}>
                    <FaUser />
                    성명
                  </label>
                  <div style={styles.fieldValue}>
                    {info?.name || '-'}
                  </div>
                </div>

                {/* 연락처 정보 */}
                <div style={{...styles.fieldGroup, ...styles.fieldGroupFull}}>
                  <label style={styles.fieldLabel}>
                    <FaPhone />
                    전화번호
                  </label>
                  <div style={{...styles.fieldValue, ...styles.phoneNumber}}>
                    {formatPhoneNumber(info?.phone)}
                  </div>
                </div>

                <div style={{...styles.fieldGroup, ...styles.fieldGroupFull}}>
                  <label style={styles.fieldLabel}>
                    <FaEnvelope />
                    이메일
                  </label>
                  <div style={styles.fieldValue}>
                    {info?.email || '-'}
                  </div>
                </div>

                {/* 직업 정보 */}
                <div style={{...styles.fieldGroup, ...styles.fieldGroupFull}}>
                  <label style={styles.fieldLabel}>
                    <FaBriefcase />
                    직업
                  </label>
                  <div style={styles.fieldValue}>
                    {info?.job || '-'}
                  </div>
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.fieldLabel}>
                    <FaBuilding />
                    소속
                  </label>
                  <div style={styles.fieldValue}>
                    {info?.company || '-'}
                  </div>
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.fieldLabel}>
                    <FaUserTie />
                    직급(직책)
                  </label>
                  <div style={styles.fieldValue}>
                    {info?.job_position || '-'}
                  </div>
                </div>

                {/* 환불 계좌 */}
                <div style={{...styles.fieldGroup, ...styles.fieldGroupFull}}>
                  <label style={styles.fieldLabel}>
                    <FaMoneyBillWave />
                    환불 계좌
                  </label>
                  <div style={styles.fieldValue}>
                    {info?.refund_account_info ? (
                      <span style={{ fontWeight: '600', color: '#059669' }}>
                        {info.refund_account_info.refund_bank_name}{' '}
                        {info.refund_account_info.refund_account}{' '}
                        ({info.refund_account_info.refund_holder})
                      </span>
                    ) : (
                      <span style={{ color: '#9ca3af' }}>미등록</span>
                    )}
                  </div>
                </div>

                {/* 계정 설정 */}
                <div style={styles.fieldGroup}>
                  <label style={styles.fieldLabel}>
                    <FaShare />
                    SNS 가입
                  </label>
                  {renderStatusIndicator(info?.is_sns, '예', '아니오')}
                </div>

                <div style={styles.fieldGroup}>
                  <label style={styles.fieldLabel}>
                    <FaBullhorn />
                    마케팅 수신
                  </label>
                  {renderStatusIndicator(info?.is_marketing_agree, '동의', '미동의')}
                </div>

                {/* 가입 설문 */}
                <div style={{...styles.fieldGroup, ...styles.fieldGroupFull}}>
                  <div style={styles.sectionTitle}>
                    <FaClipboardList />
                    가입 설문
                    {info?.survey?.created_at && (
                      <span style={styles.sectionMeta}>
                        응답일 {info.survey.created_at.slice(0, 10)}
                      </span>
                    )}
                  </div>
                </div>

                {info?.survey ? (
                  <>
                    <div style={styles.fieldGroup}>
                      <label style={styles.fieldLabel}>
                        <FaRoute />
                        유입 경로
                      </label>
                      <div style={styles.fieldValue}>{info.survey.inflow}</div>
                    </div>

                    <div style={styles.fieldGroup}>
                      <label style={styles.fieldLabel}>
                        <FaUserTag />
                        사용자 유형
                      </label>
                      <div style={styles.fieldValue}>{info.survey.user_type}</div>
                    </div>

                    <div style={{...styles.fieldGroup, ...styles.fieldGroupFull}}>
                      <label style={styles.fieldLabel}>
                        <FaStar />
                        관심 서비스
                      </label>
                      <div style={styles.fieldValue}>
                        <div style={styles.chipList}>
                          {info.survey.interests.map((interest) => (
                            <span key={interest} style={styles.chip}>{interest}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div style={{...styles.fieldGroup, ...styles.fieldGroupFull}}>
                    <div style={styles.fieldValue}>
                      <span style={{ color: '#9ca3af' }}>설문 미응답</span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 알림 모달 */}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}

      {/* CSS 애니메이션 */}
      <style>{`
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: scale(0.9) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .spinning {
          animation: spin 1s linear infinite;
        }

        @media (max-width: 640px) {
          .modal-container {
            margin: 10px;
            max-height: 95vh;
          }
          
          .modal-header {
            padding: 20px 24px;
          }
          
          .modal-title {
            font-size: 18px;
          }
          
          .header-actions {
            flex-direction: column;
            gap: 8px;
          }
          
          .login-button {
            padding: 6px 12px;
            font-size: 13px;
          }
          
          .modal-content {
            padding: 24px 20px;
          }
          
          .fields-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          
          .field-label {
            font-size: 13px;
          }
          
          .field-value {
            padding: 10px 14px;
            font-size: 13px;
          }
        }

        .modal-content::-webkit-scrollbar {
          width: 6px;
        }

        .modal-content::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 3px;
        }

        .modal-content::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 3px;
        }

        .modal-content::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }

        .field-value:hover {
          background-color: #f1f5f9;
          transition: background-color 0.2s ease;
        }

        .status-indicator {
          transition: all 0.2s ease;
        }

        .field-group:hover .status-indicator {
          transform: scale(1.1);
        }

        .login-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .close-button:focus,
        .login-button:focus {
          outline: 2px solid rgba(255, 255, 255, 0.5);
          outline-offset: 2px;
        }
      `}</style>
    </>
  );
};

export default PersonnelModal;